import { ActivityEventProcessType } from '@warebee/shared/import-converter';

export const issuesKpis /*: WarehouseKPI[] */ = [
  // Stock Discrepancy Rate
  {
    id: 'stock_discrepancy_rate',
    category: 'issues',
    title: 'Stock Discrepancy Rate',
    description: 'Percentage of inventory locations with count discrepancies',
    unit: '%',
    formula:
      '(COUNT(locations WHERE abs(system_qty - actual_qty) > 0) / COUNT(counted_locations)) * 100',
    tags: ['inventory', 'quality'],
    benchmark: {
      standards: {
        site: {
          target: 1,
          warning: { upper: 3 },
          critical: { upper: 5 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P90D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 5 },
            { label: 'Warning', min: 5.01, max: 3 },
            { label: 'Target', min: 3.01, max: 1 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P90D',
    drillDimensions: ['zone', 'product_category', 'last_activity_type'],
    alertTopic: 'warehouse.alerts.issues.stock_discrepancy',
  },
  // Mispick Rate
  {
    id: 'mispick_rate',
    category: 'issues',
    title: 'Mispick Rate',
    description: 'Percentage of picks that result in wrong item or quantity',
    unit: '%',
    formula: '(COUNT(picks WHERE status = "error") / COUNT(total_picks)) * 100',
    tags: ['picking', 'quality'],
    benchmark: {
      standards: {
        site: {
          target: 0.1,
          warning: { upper: 0.5 },
          critical: { upper: 1 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 1 },
            { label: 'Warning', min: 1.01, max: 0.5 },
            { label: 'Target', min: 0.51, max: 0.1 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['picker_id', 'product_category', 'time_of_day'],
    alertTopic: 'warehouse.alerts.issues.mispick',
    processType: ActivityEventProcessType.PICKING,
  },
  // Damage Rate
  {
    id: 'damage_rate',
    category: 'issues',
    title: 'Damage Rate',
    description:
      'Percentage of handled items damaged during warehouse operations',
    unit: '%',
    formula:
      '(COUNT(items WHERE status = "damaged") / COUNT(handled_items)) * 100',
    tags: ['quality'],
    benchmark: {
      standards: {
        site: {
          target: 0.1,
          warning: { upper: 0.5 },
          critical: { upper: 1 },
          basis: 'Legacy benchmark migrated',
        },
      },
      primarySource: 'site',
      timeWindows: [
        {
          name: 'default',
          duration: 'P28D',
          thresholdType: 'static',
          ranges: [
            { label: 'Critical', min: 0, max: 1 },
            { label: 'Warning', min: 1.01, max: 0.5 },
            { label: 'Target', min: 0.51, max: 0.1 },
          ],
        },
      ],
      metadata: { source: 'baseline' },
    },
    trendWindow: 'P28D',
    drillDimensions: ['process', 'product_category', 'handler_id'],
    alertTopic: 'warehouse.alerts.issues.damage',
    processType: ActivityEventProcessType.HANDLING_EXCEPTION,
  },
];

export default issuesKpis;
